import { Button, CircularProgress } from '@mui/material';
import { authScreen } from './authScreenStyles';

type Props = {
  children: React.ReactNode;
  disabled?: boolean;
  loading?: boolean;
  type?: 'submit' | 'button';
  sx?: object;
};

export default function AuthPrimaryButton({ children, disabled, loading, type = 'submit', sx }: Props) {
  return (
    <Button
      type={type}
      fullWidth
      disabled={disabled || loading}
      sx={{
        mt: 2.75,
        minHeight: authScreen.controlHeight,
        py: 1.25,
        borderRadius: authScreen.pillRadius,
        bgcolor: authScreen.primaryBtnBg,
        color: authScreen.primaryBtnFg,
        fontWeight: 600,
        fontSize: '0.9375rem',
        letterSpacing: '-0.01em',
        textTransform: 'none',
        fontFamily: authScreen.font,
        boxShadow: '0 1px 2px rgba(0,0,0,0.2), 0 8px 24px rgba(255,255,255,0.08)',
        transition: 'transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease',
        '&:hover': {
          bgcolor: '#FFFFFF',
          boxShadow: '0 2px 4px rgba(0,0,0,0.2), 0 12px 32px rgba(255,255,255,0.12)',
        },
        '&:active': { transform: 'scale(0.98)' },
        '&.Mui-disabled': { bgcolor: 'rgba(255,255,255,0.12)', color: authScreen.textDim, boxShadow: 'none' },
        ...sx,
      }}
    >
      {loading ? <CircularProgress size={20} sx={{ color: authScreen.primaryBtnFg }} /> : children}
    </Button>
  );
}
